/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface DollhouseSchemaReadAttributes
 */
export interface DollhouseSchemaReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof DollhouseSchemaReadAttributes
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DollhouseSchemaReadAttributes
     */
    createdAt?: Date;
    /**
     * 
     * @type {any}
     * @memberof DollhouseSchemaReadAttributes
     */
    fields?: any;
    /**
     * 
     * @type {string}
     * @memberof DollhouseSchemaReadAttributes
     */
    schemaType: DollhouseSchemaReadAttributesSchemaTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof DollhouseSchemaReadAttributes
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof DollhouseSchemaReadAttributes
     */
    uuid?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DollhouseSchemaReadAttributesSchemaTypeEnum {
    TheaterArrangement = 'theater-arrangement',
    BoardroomArrangement = 'boardroom-arrangement',
    CabaretArrangement = 'cabaret-arrangement',
    ClassroomArrangement = 'classroom-arrangement',
    RoundArrangement = 'round-arrangement',
    CocktailArrangement = 'cocktail-arrangement',
    UShapeArrangement = 'u-shape-arrangement',
    BoardroomEnsemble = 'boardroom-ensemble',
    CabaretEnsemble = 'cabaret-ensemble',
    ClassroomEnsemble = 'classroom-ensemble',
    RoundEnsemble = 'round-ensemble'
}

